var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _vm.heading.Show
    ? _c(
        "app-draggable-resize-combo",
        {
          attrs: {
            x: _vm.heading.X,
            y: _vm.heading.Y,
            width: _vm.heading.Width,
            height: _vm.heading.Height,
          },
          on: {
            "update:x": function ($event) {
              return _vm.$set(_vm.heading, "X", $event)
            },
            "update:y": function ($event) {
              return _vm.$set(_vm.heading, "Y", $event)
            },
            "update:width": function ($event) {
              return _vm.$set(_vm.heading, "Width", $event)
            },
            "update:height": function ($event) {
              return _vm.$set(_vm.heading, "Height", $event)
            },
          },
        },
        _vm._l(_vm.props, function (headingNum) {
          return _c("p", {
            directives: [
              {
                name: "safe-html",
                rawName: "v-safe-html",
                value: _vm.getSafeHtmlOfHeading(headingNum),
                expression: "getSafeHtmlOfHeading(headingNum)",
              },
            ],
            key: headingNum,
            staticClass: "line",
            style: _vm.styles[headingNum],
          })
        }),
        0
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }